import React, { useState } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { UserTypeSet } from './UserTypeSet';
import NYCUset from './NYCUset';
import { SiteTitle } from "../SiteTitle";


function Usersettings() {
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <SiteTitle />

            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="tracking tabs"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "blue",
                            }
                        }}
                    >
                        <Tab label="權限設定" value="1" />
                        <Tab label="NYCU登入使用者設定" value="2" />
                    </Tabs>
                </Box>
                <TabPanel value="1">
                    <UserTypeSet />
                </TabPanel>
                <TabPanel value="2">
                    <NYCUset />
                </TabPanel>
            </TabContext>
        </div>
    );
}

export default Usersettings;
